import { Flex, Skeleton } from 'antd';

export const InsuranceOrdersListSkeleton: React.FC = () => {
  return (
    <Flex vertical gap={16}>
      {Array.from({ length: 3 }).map(() => (
        <Skeleton.Button key={Math.random()} shape="square" block active style={{ height: 250 }} />
      ))}
    </Flex>
  );
};
